import sortByFn from 'lodash/sortBy';
import orderBy from 'lodash/orderBy';
import memoize from 'lodash/memoize';

export const sort = memoize(
  (reviews, by, tripId) => {
    if (by === 'recent') return sortByFn(reviews, ['created_at']).reverse();
    if (by === 'hi-lo') return sortByFn(reviews, ['score']).reverse();
    if (by === 'lo-hi') return sortByFn(reviews, ['score']);
    if (by === 'relevance') {
      const thisTrip = orderBy(reviews.filter(r => r.trip_id._id === tripId), ['created_at'], ['desc']);
      const notThisTrip = orderBy(reviews.filter(r => r.trip_id._id !== tripId), ['created_at'], ['desc']);

      return [...thisTrip, ...notThisTrip];
    }
    return reviews;
  },
  (reviews, by, tripId) => {
    return `${reviews.map(r => r._id).join(',')}-${by}-${tripId}`;
  }
);

export const filterByCountry = memoize(
  (reviews, country) => {
    if (country === 'all') return reviews;
    return reviews.filter(r => {
      if (r.user_id.last_country === country) return true;
      if (r.booking_id && r.booking_id.country === country) return true;
      return false;
    });
  },
  (reviews, country) => {
    return `${reviews.map(r => r._id).join(',')}-${country || 'na-country'}`;
  }
);

export const getTopCountries = memoize(
  (reviews, userCountry) => {
    const countryCount = reviews.reduce((acc, current) => {
      const country = current.user_id.last_country;
      if (country) {
        acc[country] = acc[country] > 0 ? acc[country] + 1 : 1;
      }
      return acc;
    }, {});
    const isContainUserCountry = !!countryCount[userCountry] && countryCount[userCountry] > 0;
    const countryArray = Object.keys(countryCount).map(k => ({ country: k, count: countryCount[k] }));
    const sorted = countryArray.sort((a, b) => (a.count > b.count ? -1 : 1));
    const top = sorted.map(c => c.country);

    // order by alphabet
    if (isContainUserCountry && top.indexOf(userCountry) < 0) {
      top.push(userCountry);
    }
    return top;
  },
  (reviews, userCountry) => {
    return `${reviews.map(r => r._id).join(',')}-${userCountry || 'no-country'}`;
  }
);
